import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { BasicButton } from "components/common/BasicButton";
import LogoutWrapper from "components/common/LogoutWrapper";
import { frameTransparentBackground } from "components/common/backgroundFrame";

type Props = {
    handler?: () => void;
};

const LogoutButton = ({ handler }: Props) => {
    const { t } = useTranslation();

    return (
        <LogoutWrapper>
            <LogOutBtn onClick={handler}>{`${t("logOut")}`}</LogOutBtn>
        </LogoutWrapper>
    );
};

const LogOutBtn = styled(BasicButton)`
    padding: 0.25rem;
    font-size: 0.75rem;
    border: 1px solid #ccc;
    background-color: white;
    color: black;
    :hover {
        cursor: pointer;
        filter: brightness(0.8);
    }
    /* Inside the footer frame: shares its background instead of an opaque white one. */
    ${frameTransparentBackground}
`;

export default LogoutButton;
